module.exports = __webpack_public_path__ + "static/media/index.5d51e537.png";